import { Box, Flex, Radio, RadioGroup, Stack, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { SelectableCard } from "./SelectableCard";

interface RadioOptionGroupProps {
  options: ReadonlyArray<{ value: string; labelKey: string; descriptionKey: string }>;
  value: string;
  onChange: (value: string) => void;
}

export const RadioOptionGroup = ({ options, value, onChange }: RadioOptionGroupProps) => {
  const { t } = useTranslation();

  return (
    <RadioGroup value={value} onChange={onChange}>
      <Stack direction="column" spacing="3">
        {options.map((option) => (
          <SelectableCard
            key={option.value}
            as="label"
            isSelected={value === option.value}
            borderWidth="1px"
            px="4"
            py="3"
          >
            <Flex align="center" gap="3">
              <Radio value={option.value} colorScheme="teal" />
              <Box>
                <Text fontWeight="medium" fontSize="sm">
                  {t(option.labelKey)}
                </Text>
                <Text fontSize="xs" color="smMuted">
                  {t(option.descriptionKey)}
                </Text>
              </Box>
            </Flex>
          </SelectableCard>
        ))}
      </Stack>
    </RadioGroup>
  );
};
